import { makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import { Accordion, AccordionActions, AccordionDetails, Box, Button, Divider, Grid, Chip, CircularProgress } from "@material-ui/core";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import IndicatorList from "./IndicatorList";
import CustomImageCarousel from "./CustomImageCarousel";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import NotInterestedIcon from '@material-ui/icons/NotInterested';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        display: 'flex',
        alignItems: 'center',
        flexBasis: '33.33%',
        flexShrink: 0,
        '& .MuiSvgIcon-root': {
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1),
        }
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    validated: {
        backgroundColor: '#d5fbffff'
    },
    validatedButton: {
        color: '#f50057'
    },
    loadingWrapper: {
        background: "#fff",
        width: "100%",
        height: "80%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
}));
export default function ActivityCards({ activities, handleEdit, handleVisibility, handleValidate, handleDelete, showValidate=false, loading }) {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
                <div className={classes.root}>
                {loading && (
                    <div className={classes.loadingWrapper}>
                    <CircularProgress />
                    </div>
                )}
            {
                activities?.map(activity => (
                    <Accordion className={activity.manual_validation_flag ? classes.validated: ''} key={activity._id} expanded={expanded === activity._id} onChange={handleChange(activity._id)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id="panel1bh-header"
                        >
                            <div className={classes.heading}>
                                {activity?.visibility ? <Visibility /> : <VisibilityOff />}
                                {activity?.info?.name}
                            </div>
                            <IndicatorList activity={activity} />

                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3}>
                                    <Box component="div" className={classes.boxWrapper}>
                                        <div className="boxItem">
                                            {activity?.info?.description}
                                        </div>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} md={9}>
                                    {/* <ChipList items={[activity.info.category.name]} /> */}
                                    <CustomImageCarousel defaultCaption={activity?.info?.name} images={activity.images} itemsToShow={6} />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                        <Divider />
                        <AccordionActions>
                            {activity?.images.length ? <Chip
                                label={ activity?.generic_images_flag ? "Generic Images" : "Provider Images"}
                                color="secondary"
                                style={{
                                backgroundColor:
                                activity?.generic_images_flag ? "#0097a7" : "#666666",
                                position: 'absolute', left: 7
                                }}
                            />: ""}
                            {activity.branch_id && showValidate&& <Button size="small"
                                className={activity.manual_validation_flag ? classes.validatedButton : ''}
                                startIcon={activity.manual_validation_flag ?  <NotInterestedIcon/> :<ThumbUpIcon />}
                                onClick={handleValidate(activity)}>
                                {activity.manual_validation_flag ? 'Invalidate' :'Validate'}
                            </Button>}
                            <Button size="small"
                                onClick={handleVisibility(activity)}
                                startIcon={activity?.visibility ? <VisibilityOff /> : <Visibility />}
                            >
                                {activity?.visibility ? 'mark hidden' : 'mark visible'}
                            </Button>
                            <Button size="small"
                                color="secondary"
                                startIcon={<DeleteIcon />}
                                onClick={handleDelete(activity)}>
                                Delete
                            </Button>
                            <Button size="small"
                                color="primary"
                                startIcon={<EditIcon />}
                                onClick={handleEdit(activity)}>
                                Edit
                            </Button>
                        </AccordionActions>
                    </Accordion>
                ))
            }
        </div>
    );
}